import script from "./CommunityCreate.vue?vue&type=script&setup=true&lang=js"
export * from "./CommunityCreate.vue?vue&type=script&setup=true&lang=js"

import "./CommunityCreate.vue?vue&type=style&index=0&id=2ac11904&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ac11904"]])

export default __exports__